import React, { useEffect, useContext, useState } from "react";
import Page from "../components/Page";
import { AuthContext } from "../providers/AuthProvider";
import { SettingsContext } from "../providers/SettingsProvider";
import API from "../api";
import StandingsView from "../components/StandingsView";
import { Button } from "react-bootstrap";
import FavTeam from "../modals/FavTeam";
import Loader from "../components/Loader";
import BackButton from "../components/BackButton";
import ScrollToTop from "../components/ScrollToTop";
import StandingsSearch from "../components/StandingsSearch";
import { getTeamLogoUrl, rndInt } from "../helpers/utils";
import { useParams, useNavigate } from "react-router-dom";
import ClientCache from "../cache";

const styles = {
  text: {
    textTransform: "uppercase",
    fontSize: "1.3rem",
    fontWeight: "bold",
  },
};

const Leagues = () => {
  const { leagueId } = useParams();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const { currentRound } = useContext(SettingsContext);
  const [standingItems, setStandingItems] = useState([]);
  const [selectLeagueModal, setSelectLeagueModal] = useState(false);
  const [searchReset, setSearchReset] = useState(0);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!leagueId) return;

    const fetchLeague = async (selectedFavTeamId) => {
      const clientCache = ClientCache.getInstance();
      const cachedItems = clientCache.get(selectedFavTeamId);
      try {
        setLoading(true);
        if (cachedItems !== null) {
          setStandingItems(cachedItems);
        } else {
          const res = await API.fetchLeague({
            leagueId: selectedFavTeamId,
            currentRound,
          });
          setStandingItems(res.data);
          clientCache.set(selectedFavTeamId, res.data);
        }
      } catch (err) {
        console.log(err);
      } finally {
        setLoading(false);
      }
    };
    fetchLeague(leagueId, currentRound);
  }, [leagueId, currentRound]);

  const showModal = () => {
    setSelectLeagueModal(true);
  };

  const hideModal = () => {
    setSelectLeagueModal(false);
  };

  const onSelectTeam = (option) => {
    setSearchReset(+new Date());
    navigate(`/leagues/${option.value}`);
    hideModal();
  };

  return (
    <Page>
      <ScrollToTop />
      <div className="page-bar">
        {" "}
        <div className="inner">
          <div>
            <BackButton />
            {leagueId && (
              <Button
                size="sm"
                variant="light"
                style={{
                  ...styles.text,
                  marginLeft: 8,
                  display: "inline-flex",
                  alignItems: "center",
                }}
                onClick={showModal}
              >
                <img
                  style={{
                    height: 24,
                    objectFit: "contain",
                  }}
                  src={getTeamLogoUrl(leagueId, rndInt())}
                  alt=""
                />
                &nbsp;Ліга&nbsp;
                <i
                  style={{ display: "flex" }}
                  className="bi bi-caret-down-fill"
                ></i>
              </Button>
            )}{" "}
          </div>

          <StandingsSearch
            reset={searchReset}
            user={user}
            items={standingItems}
            setItems={setStandingItems}
          />
        </div>
      </div>
      {loading ? <Loader /> : <StandingsView items={standingItems} />}
      <FavTeam
        show={selectLeagueModal}
        onHide={hideModal}
        selectMode={true}
        onSelect={onSelectTeam}
        defaultTeamId={+leagueId}
      />
    </Page>
  );
};

export default Leagues;
